import { Trans } from '@lingui/react';
import { useQueryClient } from '@tanstack/react-query';

import AdminToolbar, {
  AdminButton,
} from '@rover/react-lib/src/components/AdminToolbar/AdminToolbar';
import useLocationContext from '@rover/react-lib/src/context/useLocationContext';
import {
  EnhancedPersonSitterProfile,
  getApiPersonFullSitterProfileRetrieveQueryKey,
} from '@rover/rsdk/src/apiClient/latest';

const getSlugFromPathname = (path: string): string => {
  const splitPathname = path.split('/');
  return splitPathname[splitPathname.length - 2];
};

const SitterProfilePageToolbar = () => {
  const location = useLocationContext();
  const { pathname } = location;
  const queryClient = useQueryClient();

  const slug = getSlugFromPathname(pathname);
  // getting service for the react-query key
  const search = new URLSearchParams(location.search);
  const service = search.get('service_type');
  const serviceParams = service ? { service } : undefined;
  const nocache = search.get('no_cache');
  const nocacheParams = nocache ? { no_cache: '1' } : undefined;
  const key = getApiPersonFullSitterProfileRetrieveQueryKey({
    slug,
    ...serviceParams,
    ...nocacheParams,
  });

  const sitterData = queryClient.getQueryData(key) as EnhancedPersonSitterProfile;

  const impersonatingUrl = `/admin/people/person/become_person/${sitterData?.opk}/?next=${pathname}`;
  const providerProfileUrl = `/admin/services/providerprofile/?provider__id=${sitterData?.personId}`;
  const sitterPeopleUrl = `/admin/people/person/?id=${sitterData?.personId}`;

  return (
    <AdminToolbar>
      <AdminButton href={providerProfileUrl}>
        <Trans id="View Provider Profile" />
      </AdminButton>
      <AdminButton href={sitterPeopleUrl}>
        <Trans id="View in People" />
      </AdminButton>
      <AdminButton href={impersonatingUrl}>
        <Trans id={`Login as ${sitterData?.firstName}`} />
      </AdminButton>
    </AdminToolbar>
  );
};

export default SitterProfilePageToolbar;
